import React, { Component } from 'react';
import css from './ResetPassword.module.scss';
import Message from '../../components/UI/Message';
import Layout from '../../components/Layout/Layout';
import SetPasswordAndConfirm from '../Widgets/SetPasswordAndConfirm';
import Button from '../../components/UI/Button/index.tsx';
import Loader from '../../components/UI/Loader';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: this.props.ltaResetPasswordExperience.enabled
        ? encodeURIComponent(
            `greenlight://${this.props.role}/${this.props.userId}/${this.props.resetToken}`
          )
        : '',
      password: '',
      buttonEnabled: false
    };

    if (this.props.ltaResetPasswordExperience.enabled) {
      this.props.validateResetPasswordToken({
        url: this.state.url
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.analytics.trackEvent('Reset Password Viewed');
  }

  componentDidUpdate() {
    if (this.props.ltaResetPasswordExperience.enabled && this.props.error) {
      this.props.createError({
        message: 'Password reset link has expired. Please try again.'
      });
      // redirect to beginning of reg flow
      if(this.props.redirectOnError) {
        this.props.setNextRegStep('phone');
      }
    }
  }

  resetPassword = async () => {
    try {
      // SetPasswordAndConfirm checks that password and confirmPassword agree
      const { errorChecking } = this.refs.setPasswordAndConfirm;
      await errorChecking();
      const { userId, resetToken, deviceToken } = this.props;

      if (this.props.ltaResetPasswordExperience.enabled) {
        // LTA Reset Password
        this.props.ltaResetPassword({
          url: this.state.url,
          device_id: deviceToken,
          password: this.state.password
        });
      } else {
        // Legacy Reset Password
        this.props.resetPassword({
          userId,
          token: resetToken,
          deviceUuid: deviceToken,
          newPassword: this.state.password, // Since password is already checked
          verifyPassword: this.state.password // Sending it twice
        });
      }
    } catch {
      window.scrollTo(0, 0);
    }
  };

  onEnableChanged = (question, buttonEnabled) => {
    this.setState({ buttonEnabled });
  };

  onSetPasswordAndConfirmChanged = (widget, value) => {
    this.setState({ password: value });
  };

  render() {
    if (this.props.ltaResetPasswordExperience.enabled) {
      if (
        this.props.loading ||
        !this.props.validateResetPasswordTokenComplete
      ) {
        return <Loader />;
      }
    }

    return (
      <div>
        <Layout>
          <div className="Card-Wrapper">
            <div className="bar" />
            <div className={css.ResetPasswordMainBox}>
              <h1 data-e2e="reset-password-header">Reset Password</h1>
              <h2 data-e2e="reset-password-subheader">
                Enter your New Password
              </h2>
              <Message error={this.props.error} text={this.props.message} />
              <SetPasswordAndConfirm
                ref={'setPasswordAndConfirm'}
                shouldEnable={this.onEnableChanged}
                widget={'set_user_password_and_confirm'}
                changeAnswerValue={this.onSetPasswordAndConfirmChanged}
                index={0}
                questionsAndAnswers={{}}
                resetPassword={true}
                {...this.props}
              />
              <Button
                onClick={this.resetPassword}
                disabled={!this.state.buttonEnabled}
                loading={this.props.loading}
                text="Reset Password"
              />
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

export default ResetPassword;
